export const faculties = [
  {
    slug: 'millionaires-connect',
    title: 'Millionaires Connect (The School Of Wealth - Adults)',
    summary: '90-day coaching intensive to build wealth, financial discipline, and strategic execution.',
    logo: '/logos/millionaires_connect_transparent.png',
    details: {
      overview: 'A focused wealth pathway designed to move you from survival to growth with disciplined habits, strategic direction, and Kingdom-aligned execution.',
      highlights: [
        '90-day coaching intensive with weekly accountability',
        'Financial thinking, tracking, and predictable income systems',
        'Prayer integrated with strategy and execution'
      ],
      outcome: 'Clarity, momentum, and a concrete wealth system you can sustain.'
    }
  },
  {
    slug: 'masters-of-the-economy',
    title: 'Masters of the Economy (Kingdom Economics)',
    summary: 'One-year pathway to build a Kingdom economic blueprint and sustainable wealth systems.',
    logo: '/logos/masters_economy_transparent.png',
    details: {
      overview: 'Masters of the Economy is a transformational School of SHEM course designed to equip families, individuals, business owners, and leaders to master their economic environment through biblical principles and practical strategy. Drawing from Dr. Tich’s books, students learn to build wealth, create sustainable income, steward resources wisely, and establish lasting Kingdom economic influence.',
      highlights: [
        'Business Success',
        'Kingdom Economics',
        'Transformation',
        'Leadership',
        'Success'
      ],
      learning: [
        'Kingdom-first, Bible-based curriculum',
        'Integrated life development approach',
        'Practical, implementation-focused learning',
        'Personal mentorship and accountability',
        'Leadership and influence training',
        'Business and economic empowerment',
        'Family and generational legacy emphasis',
        'Real-life application—not just information',
        'Community of growth-minded Kingdom builders',
        'Framework for lifelong transformation'
      ],
      outcomes: [
        'Kingdom Purpose & Identity',
        'Spiritual Maturity & Biblical Wisdom',
        'Personal Transformation',
        'Leadership Excellence & Influence',
        'Business & Economic Empowerment',
        'Strong Families & Generational Legacy',
        'Practical Kingdom Living',
        'Mentorship & Accountability',
        'Kingdom Community & Strategy'
      ]
    }
  },
  {
    slug: 'building-a-family-economy',
    title: 'Building a Family Economy',
    summary: 'Build a sustainable family economy through practical, Kingdom-aligned lessons.',
    logo: '/School Of SHEM Building A family Economy.png',
    details: {
      overview: 'A practical 20-lesson course designed to help families develop a sustainable family economy and build a lasting generational legacy.',
      highlights: [
        '20 practical family economy lessons',
        'Daily implementation and family development',
        'Study book and workbook available in the store'
      ],
      outcome: 'A practical blueprint for building and sustaining a strong family economy.'
    }
  },
  {
    slug: 'success-paradigms-101',
    title: 'Success Paradigms 101 (The School of Success)',
    summary: 'Timeless principles that govern consistent growth, progress, and achievement.',
    logo: '/logos/success_paradigm_transparent.png',
    details: {
      overview: 'Learn and apply the laws that produce consistent growth, discipline, and purposeful achievement.',
      highlights: [
        'Principle-based success framework',
        'Mindset, clarity, and disciplined execution',
        'Tools for measuring progress and momentum'
      ],
      outcome: 'A success mindset and practical habits that build lasting results.'
    }
  },
  {
    slug: 'transformational-leadership',
    title: 'Transformational Leadership School',
    summary: 'Develop character, sharpen vision, and lead with Kingdom influence.',
    logo: '/logos/leadership_school_transparent.png',
    details: {
      overview: 'Over 15 practical leadership modules to strengthen character, sharpen vision, and build influence.',
      highlights: [
        'Character formation and responsibility',
        'Vision, strategy, and leadership systems',
        'Leading self and others with clarity'
      ],
      outcome: 'Leadership capacity that produces real impact.'
    }
  },
  {
    slug: 'kingdom-parenting-101',
    title: 'Kingdom Parenting 101',
    summary: 'Raise children with wisdom, discipline, and purpose using Kingdom blueprints.',
    logo: '/logos/kingdom_parenting_transparent.png',
    details: {
      overview: 'Practical principles for nurturing identity, character, discipline, faith, and vision in children.',
      highlights: [
        'Family governance and household unity',
        'Tools for daily spiritual formation',
        'Guidance for each stage of growth'
      ],
      outcome: 'A strong, God-centered household that prepares the next generation.'
    }
  },
  {
    slug: 'faith-life',
    title: 'Faith Life (The School of Faith)',
    summary: 'Strengthen faith foundations through trust, obedience, and spiritual confidence.',
    logo: '/logos/faith_life_transparent.png',
    details: {
      overview: 'Rooted in Abraham’s example, this program builds trust in God and a resilient faith walk.',
      highlights: [
        'Faith foundations and spiritual confidence',
        'Obedience, trust, and identity formation',
        'Overcoming challenges through alignment'
      ],
      outcome: 'A strong spiritual foundation for life and leadership.'
    }
  },
  {
    slug: 'total-life-transformation',
    title: 'Total Life Transformation (The School of Spirituals)',
    summary: 'Grow spiritually, renew the mind, and live a transformed life.',
    logo: '/logos/total_life_transparent.png',
    details: {
      overview: 'A transformation journey focused on renewing the mind and living out the Word in everyday life.',
      highlights: [
        'Over 15 modules for spiritual growth',
        'Mind renewal and character formation',
        'Practical daily living applications'
      ],
      outcome: 'Lasting change through the transforming power of God’s Word.'
    }
  },
  {
    slug: 'dynamic-church',
    title: 'The Dynamic Church (Church Planting)',
    summary: 'Understand the true function of the Church and build in alignment with God’s design.',
    logo: '/logos/dynamic_church_transparent.png',
    details: {
      overview: 'Equips leaders and believers to serve, build, and contribute to a life-giving church expression.',
      highlights: [
        'Church purpose and function',
        'Practical courses for ministry effectiveness',
        'Building healthy, impactful communities'
      ],
      outcome: 'A dynamic church life that aligns with God’s design.'
    }
  },
  {
    slug: 'kingdom-kids-365',
    title: 'Kingdom Kids 365',
    summary: '365 stories to nurture faith, character, and daily spiritual formation in children.',
    logo: '/logos/kingdom_kids_365_transparent.png',
    details: {
      overview: 'A daily resource to invest in children’s spiritual growth and strengthen parent-child bonds.',
      highlights: [
        '365 faith-building stories',
        'Guided daily conversations',
        'Values and character formation'
      ],
      outcome: 'Confident, faith-filled children with strong foundations.'
    }
  },
  {
    slug: 'millionaire-kids-klub',
    title: 'Millionaire Kids Klub',
    summary: 'Introduce children to economic mastery through stewardship and value creation.',
    logo: '/logos/millionaire_kids_klub_transparent.png',
    details: {
      overview: 'Age-appropriate lessons that build stewardship, value creation, and economic confidence.',
      highlights: [
        'Simple wealth-building principles for kids',
        'Discipline, preparation, and responsibility',
        'Foundations of stewardship and purpose'
      ],
      outcome: 'Children prepared with an economic mindset for the future.'
    }
  },
  {
    slug: 'married-and-loving-it',
    title: 'Married and Loving It',
    summary: 'Strengthen communication, intimacy, and unity for a joyful, purpose-filled marriage.',
    logo: '/logos/married_loving_it_transparent.png',
    details: {
      overview: 'Over 30 courses to deepen intimacy, resolve conflict, and build unity in marriage.',
      highlights: [
        'Communication and conflict resolution',
        'Purpose-filled partnership and unity',
        'Practical tools for lasting joy'
      ],
      outcome: 'A stable, joyful marriage that becomes a strong foundation for family success.'
    }
  },
  {
    slug: 'transformation-africa',
    title: 'Transformation Africa',
    summary: 'Lead transformational change across communities and nations in Africa.',
    logo: '/logos/transformation_africa_transparent.png',
    details: {
      overview: 'Ten focused modules for leaders called to shape the future of Africa through vision and responsibility.',
      highlights: [
        'Strategic leadership for continental impact',
        'Responsibility and vision development',
        'Practical transformation frameworks'
      ],
      outcome: 'Courageous leaders prepared to drive lasting transformation.'
    }
  },
  {
    slug: 'academic-excellence',
    title: 'Academic Excellence',
    summary: 'Develop knowledge, thinking, and intellectual mastery for lifelong impact.',
    logo: '/logos/genesis_transparent.png',
    details: {
      overview: 'Develop knowledge, thinking, and intellectual mastery that supports excellence in every domain.',
      highlights: [
        'Academic discipline and thinking mastery',
        'Structured learning habits',
        'Tools for long-term growth'
      ],
      outcome: 'A strong intellectual foundation for leadership and influence.'
    }
  }
];
